import { render, staticRenderFns } from "./RiskManagement.vue?vue&type=template&id=2beef6fd&scoped=true&"
import script from "./RiskManagement.vue?vue&type=script&lang=ts&"
export * from "./RiskManagement.vue?vue&type=script&lang=ts&"
import style0 from "./RiskManagement.vue?vue&type=style&index=0&id=2beef6fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beef6fd",
  null
  
)

export default component.exports